import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TimePointListEntry } from '../../../core/gb-api';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { NgTemplateOutlet, PlatformLocation } from '@angular/common';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { KompaktdarstellungTemplateComponent } from '../kompakt-darstellung-template.component';
import { ComponentLocationStrategy } from '../../services/location-strategy/component-location-strategy';
import { TimepointService } from '../../../core/services/timepoint.service';
import { DokulinkItemBuilderFactory } from '../../components/dokulink/dokulinkItemBuilderFactory';
import { LinkComponent } from '../../components/link/link.component';
import { DokulinkComponent } from '../../components/dokulink/dokulink.component';
import { TranslatePipe } from '@ngx-translate/core';
import { DatumPipe } from '../../pipes/simple/datum.pipe';
import { DatumZeitPipe } from '../../pipes/simple/datumZeit.pipe';
import { FormatGeometergeschaeftsnummerPipe } from '../../pipes/format/format-geometergeschaeftsnummer.pipe';
import { FormatTimepointPipe } from '../../pipes/format/format-timepoint.pipe';
import { CmisComponent } from '../../components/cmis/cmis.component';

@Component({
  selector: 'cap-kompakt-timepoint',
  templateUrl: './kompakt-timepoint.component.html',
  styleUrls: ['./kompakt-timepoint.component.scss'],
  imports: [
    NgTemplateOutlet,
    LinkComponent,
    DokulinkComponent,
    CmisComponent,
    TranslatePipe,
    DatumPipe,
    DatumZeitPipe,
    FormatGeometergeschaeftsnummerPipe,
    FormatTimepointPipe
  ]
})
export class KompaktTimepointComponent extends KompaktdarstellungTemplateComponent implements OnInit {
  currentItem: TimePointListEntry;

  get item() {
    return this.currentItem;
  }

  @Input()
  set item(value: TimePointListEntry) {
    this.currentItem = value;
    if (!value) {
      return;
    }
    this.newItemInit();
  }

  @Input()
  loeschgeschaeft: any;

  @ViewChild('ersterfassung', { static: true }) ersterfassungTemplate: TemplateRef<any>;
  @ViewChild('ersterfassung_uebergeben', { static: true }) ersterfassungUebergebenTemplate: TemplateRef<any>;
  @ViewChild('simple_timepoint', { static: true }) simpleTtimepointTemplate: TemplateRef<any>;
  @ViewChild('loeschgeschaeft', { static: true }) loeschgeschaeftTemplate: TemplateRef<any>;
  @ViewChild('geometergeschaeft', { static: true }) geometergeschaeft: TemplateRef<any>;
  @ViewChild('loeschGeometergeschaeft', { static: true }) loeschGeometergeschaeftTemplate: TemplateRef<any>;

  @ViewChild('typ00', { static: true }) typ00Template: TemplateRef<any>;
  @ViewChild('typ01', { static: true }) typ01Template: TemplateRef<any>;

  private presentation: TemplateRef<any>;
  isCmisGeschaeftConfigured = false;

  constructor(
    protected formatService: FormatConfigService,
    protected location: PlatformLocation,
    private locationStrategy: ComponentLocationStrategy,
    private timepointService: TimepointService,
    protected dokuLinkBuilderFactory: DokulinkItemBuilderFactory
  ) {
    super(formatService, 'TIMEPOINT', location, locationStrategy);
    keysToTranslate<string>(['DetailsZumLöschgeschaeftAnzeigen']);
  }

  ngOnInit() {
    super.ngOnInit();
    if (!this.item) {
      return;
    }
    this.addSub(
      this.formatService.settingsConfig$.subscribe((config) => {
        this.isCmisGeschaeftConfigured = config?.isCmisConfigured;
      })
    );
    this.newItemInit();
  }

  private newItemInit() {
    if (this.isLoeschgeschaeft() && this.item.id && this.item.id.id === this.timepointService.timepointCtx.timepointId) {
      return;
    }
    if (this.isLoeschgeschaeft()) {
      this.presentation = this.loeschgeschaeftTemplate;
      return;
    }
    switch (this.item.type) {
      case 'GB_GESCHAEFT':
        this.presentation = this.configuredTemplate;
        break;
      case 'ERSTERFASSUNG':
        this.presentation = this.ersterfassungTemplate;
        break;
      case 'ERSTERFASSUNG_UEBERGEBEN':
        this.presentation = this.ersterfassungUebergebenTemplate;
        break;
      case 'SIMPLE':
        this.presentation = this.simpleTtimepointTemplate;
        break;
      case 'GEO_GESCHAEFT':
        this.presentation = this.geometergeschaeft;
        break;
    }
  }

  isLoeschgeschaeft(): boolean {
    return this.loeschgeschaeft != null;
  }

  getDefaultTemplate(): TemplateRef<any> {
    return this.typ01Template;
  }

  registerTemplates() {
    this.bindTemplates(this.typ00Template, 'TIMEPOINT_TYP00');
    this.bindTemplates(this.typ01Template, 'TIMEPOINT_TYP01');
  }

  public get element(): TemplateRef<any> {
    return this.presentation;
  }

  get tooltipPlacement() {
    return this.isLoeschgeschaeft() ? 'bottom' : 'top auto';
  }
}
